import { KeyboardEvent } from 'react';

// Whether a keydown is a deliberate Enter press, matching what keypress used
// to report: not a held key repeating, and not Enter confirming IME text.
// Safari ends the composition before the keydown, so isComposing is already
// false there and only keyCode 229 marks the event as part of the IME.
export const isReturnKeyPress = (e: KeyboardEvent) =>
  e.key === 'Enter' &&
  !e.repeat &&
  !e.nativeEvent.isComposing &&
  e.keyCode !== 229;
